import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportOrganisationsMutation,
  ExportOrganisationsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportOrganisations = graphql(`
  mutation exportOrganisations(
    $request: ExportOrganisationRequest!
    $exportFormat: ExportFormatArgs!
  ) {
    exportOrganisations(ExportOrganisationRequest: $request, ExportFormat: $exportFormat) {
      id
    }
  }
`);

export function useExportOrganisations(
  options?: UseMutationOptions<
    ExportOrganisationsMutation,
    unknown,
    ExportOrganisationsMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportOrganisations, options);
  return { ...rest, data: data?.exportOrganisations };
}
